<template>
    <div class="innerMongolia-home">
        <!-- 头部导航 -->
        <headerBlack-view></headerBlack-view>
        <!-- 主体内容 -->
        <div class="innerMongolia-home-container">
              <div class="innerMongolia-banner">
                <div class="innerMongolia-banner-wrapper main">
                    <img class="title" src="../../../assets/wisdom/innerMongolia_title.png">
                    <p class="introduce">为推动内蒙古自治区三科统编教材使用，提高三科统编教材教师使用国家通用语言文字开展教育教学的能力，
                        重点提升义务教育阶段民族语言授课学校的三科教师教学胜任水平，首都师范大协调河北师范大学、
                        天津师范大学，按照精准培训目标，制定本次专项培训工作的实施方案。</p>
                </div>
              </div>
              <div class="sub-navigate">
                  <ul class="sub-nav-ul main flex-layout">
                        <li v-for="(item,index) in navigate" 
                            :key="index" 
                            :class="{'active': active == index + 1}"
                            @click="handleClick(item,index)"
                            class="csp">
                            {{item.name}}
                        </li>
                  </ul>
              </div>
              <router-view :columnId="currentColumnId"></router-view>
        </div>
        <footer-view></footer-view>
  </div>
</template>

<script>
export default {
    data() {
        return {
            navigate:[ //导航list
                // {   
                //     name:'新闻资讯',
                //     path:'news'
                // },
                // {   
                //     name:'精品课程',
                //     path:'course'
                // },
                // {
                //     name:'专家团队',
                //     path:'expert'
                // },
                // {
                //     name:'项目校名录',
                //     path:'directory'
                // }
            ],
            active:1, //当前被选中的导航
            currentColumnId:0,
        }
    },
    watch:{},
    methods: {
        handleClick(item,index) {
            this.active = index + 1;
            sessionStorage.setItem('wsActive',index+1);
            this.currentColumnId = item.id
            this.$nextTick(function(){
                this.$router.push(item.path);
            })
           
        },
        async getColumnLsit() {
            let id = 110  //110是内蒙古
            let resData = await Api.Wisdom.getColumnLsit(id)
            // console.log(resData)       
            this.navigate = resData.data
            this.currentColumnId = this.navigate[0].id
        },
        init() {
            if(sessionStorage.getItem('wsActive')) {
                this.active = sessionStorage.getItem('wsActive')
            } else {
                let xPath = window.location.href.split('/')[window.location.href.split('/').length - 1];
                this.navigate.map((item,index)=>{
                    if(item.path === xPath) {
                        this.active = index + 1
                        sessionStorage.setItem('wsActive',this.active);
                    }
                })
            }
        }
    },
    created() {
        sessionStorage.setItem('projectID',110);
    },
    mounted() {
        this.getColumnLsit();
        this.init();
    },
    destroyed() {
        sessionStorage.removeItem('wsActive')
    }
}
</script>

<style lang="less" scoped>
    @import "../wisdom/less/wisdom_home.less";
</style>